import {
  Autocomplete,
  Popper,
  TextField,
  autocompleteClasses,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/styles";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '11px',
    '& li': {
      padding: '3px 8px',
    },
  },
}));

const OrderCategory = forwardRef((props, ref) => {
  const [orderType, setOrderType] = useState(props.value);
  const theme = useTheme();
  const [orderTypeOptions, setOrderTypeOptions] = useState([]);
  const refInput = useRef();
  // const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucher}`;
  useEffect(() => {
    const orderType = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}?size=100`;
      const orderCategories = await OAuthService.getList(url);
      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return { label: value.name, value: value.name };
        }
      );
      setOrderTypeOptions(result);
    };
    orderType();
  }, []);
  const handleEditCustomerVendor = (event, value) => {
    setOrderType(value);
  };

  useEffect(() => {
    // get ref from React component
    window.setTimeout(() => {
      const eInput = refInput.current;
      eInput.focus();
    });
  }, []);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return orderType.value;
      },
      focusIn() {
        var eInput = refInput.current;
        eInput.focus();
        eInput.select();
      },
    };
  });

  return (
    <>
      <Autocomplete
        disableClearable
        PopperComponent={StyledPopper}
        options={orderTypeOptions}
        size="small"
        value={orderType}
        onChange={handleEditCustomerVendor}
        onInputChange={handleEditCustomerVendor}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            placeholder={"Select "}
            inputRef={refInput}
            className="customDatePickerDiscount"
            sx={{
              border: !orderType ? "1px solid red" : "none",
              fontSize: "smaller",
              backgroundColor: theme.palette.background.paper,
              "& .MuiInputBase-input": {
                color: theme.palette.text.primary,
              },
            }}
          />
        )}
      />
    </>
  );
});

export default OrderCategory;
